import { useRef, useCallback } from 'react';

/**
 * Returns a function to get the value passed as parameter.
 * Everytime the passed value changed, the returned function will return the new value.
 * However, the returned function will be always the same.
 * @template T
 * @param {T} value
 * @returns {() => T}
 */
function useGetSync(value) {
  /** @type {import('react').MutableRefObject<T>} */
  var ref = useRef(value);
  ref.current = value;
  var get = useCallback(function () {
    return ref.current;
  }, []);
  return get;
}

export { useGetSync };
//# sourceMappingURL=useGetSync.js.map
